const dataOffersFrFr = [
  {
    offer: 'FOOTER_TOP',
    children: [
      {
        id: 'whatsapp',
        imageSrc: 'social-whatsapp-24.svg',
        alt: 'Besoin d’aide, d’info ?',
        title: 'Besoin d’aide, d’info&nbsp;?',
        text: 'Contactez-nous via Whatsapp',
        linkTitle: 'Contactez-nous via Whatsapp',
      },
      {
        id: 'contact',
        imageSrc: 'phone-black-24.svg',
        alt: 'Besoin d’aide, d’info ?',
        title: 'Besoin d’aide, d’info&nbsp;?',
        text: 'Contactez-nous',
        linkTitle: 'Besoin d’aide, d’info ?',
      },
      {
        id: 'acceo',
        imageSrc: 'ear-deaf-black-24.svg',
        alt: 'Sourd ou malentendant ?',
        title: 'Sourd ou malentendant&nbsp;?',
        text: 'Contactez-nous avec ACCEO',
        linkTitle: 'Contactez-nous avec ACCEO',
      },
      {
        id: 'assistance',
        imageSrc: 'user-headset-black-24.svg',
        alt: 'Assistance',
        title: 'Assistance',
        text: 'Aide en ligne pour une utilisation optimale',
        linkTitle: 'Assistance',
      },
    ],
  },
  {
    offer: 'FOOTER_MIDDLE_1',
    children: [
      {
        id: 'pre-contractual-document',
        text: 'Document d’information précontractuelle',
        linkUrl: 'be/fr/pdf/information-precontractuelle.pdf',
        linkTitle: 'Document d’information précontractuelle',
      },
      {
        id: 'retraction-form',
        text: 'Formulaire de rétractation',
        linkUrl: 'be/fr/pdf/formulaire-retractation.pdf',
        linkTitle: 'Formulaire de rétractation',
      },
      {
        id: 'termination-form',
        text: 'Formulaire de résiliation',
        linkUrl: 'be/fr/pdf/formulaire-resiliation.pdf',
        linkTitle: 'Formulaire de résiliation',
      },
    ],
  },
  {
    offer: 'FOOTER_MIDDLE_2',
    children: [
      {
        id: 'rc-cc',
        text: 'Conditions et récapitulatifs contractuels',
        linkUrl: 'be/fr/document-contractuel',
        linkTitle: 'Conditions et récapitulatifs contractuels',
      },
      {
        id: 'service-information',
        text: 'Information de service',
        linkUrl: 'be/fr/informations-de-service',
        linkTitle: 'Information de service',
      },
      {
        id: 'prices',
        text: 'Tarifs',
        linkUrl: 'be/fr/document-contractuel?anchor=pricelist',
        linkTitle: 'Tarifs',
      },
    ],
  },
  {
    offer: 'FOOTER_BOTTOM',
    children: [
      {
        id: 'personal-data-cookies',
        text: 'Données personnelles et cookies',
        linkUrl: 'be/fr/donnees-personnelles-politique-cookies',
        linkTitle: 'Données personnelles et cookies',
      },
      {
        id: 'manage-cookies',
        text: 'Gérer les cookies',
        linkTitle: 'Gérer les cookies',
      },
      {
        id: 'launch-alert',
        text: 'Lancer une alerte',
        linkUrl: 'https://orange.integrityline.org/',
        linkTitle: 'Lancer une alerte',
      },
      {
        id: 'legal-information',
        text: 'Informations légales',
        linkUrl: 'be/fr/informations-legales',
        linkTitle: 'Informations légales',
      },
      {
        id: 'mediation',
        text: 'Médiateur des communications électroniques',
        linkUrl: 'be/fr/mediateur-communications-electroniques',
        linkTitle: 'Médiateur des communications électroniques',
      },
    ],
  },
  {
    offer: 'FOOTER_LOGOS',
    children: [
      {
        id: 'nordnet',
        imageSrc: 'logo-nordnet-white.svg',
        alt: 'Nordnet',
        width: '155',
        height: '28',
      },
      {
        id: 'orange',
        imageSrc: 'logo-orange-with-baseline.png',
        alt: 'Une société du groupe Orange',
        width: '134',
        height: '36',
      },
    ],
  },
  {
    offer: 'FOOTER_TITLE_1',
    children: [
      {
        text: 'Documents pratiques',
      },
    ],
  },
  {
    offer: 'FOOTER_TITLE_2',
    children: [
      {
        text: 'Liens pratiques',
      },
    ],
  },
];

export default dataOffersFrFr;
